export default {"src":"/_next/static/media/travel.dfd36c78.svg","height":521,"width":850};